import { connect } from 'react-redux';
import { logoutUser } from 'shared/services/authService';
import Logout from './Logout';

const mapDispatchToProps = {
  logoutUser,
};

export default connect(null, mapDispatchToProps)(Logout);
